import {useCallback, useEffect, useRef, useState} from 'react';
import MembershipPackUI from './MembershipPackUI';

const MembershipPacksRow = ({plans, companyId}) => {
  const rowRef = useRef(null);
  const [scrollState, setScrollState] = useState({previous: false, next: false});

  const updateScrollState = useCallback(() => {
    const row = rowRef.current;
    if (!row) return;

    const nextState = {
      previous: row.scrollLeft > 1,
      next: row.scrollLeft + row.clientWidth < row.scrollWidth - 1,
    };
    setScrollState(current =>
      current.previous === nextState.previous && current.next === nextState.next
        ? current
        : nextState
    );
  }, []);

  useEffect(() => {
    const row = rowRef.current;
    updateScrollState();
    const observer = new ResizeObserver(updateScrollState);
    observer.observe(row);
    return () => observer.disconnect();
  }, [plans, updateScrollState]);

  const scroll = direction => {
    const row = rowRef.current;
    const card = row.firstElementChild;
    if (!card) return;
    const gap = parseFloat(window.getComputedStyle(row).columnGap) || 0;
    row.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: 'smooth',
    });
  };

  return (
    <div className="membership-packages mb-3 mt-3">
      {(scrollState.previous || scrollState.next) && (
        <div className="membership-packages__controls">
          <button
            aria-label="Previous memberships"
            className="btn btn-outline-dark btn-sm"
            disabled={!scrollState.previous}
            onClick={() => scroll(-1)}
            type="button"
          >
            <span aria-hidden="true">←</span>
          </button>
          <button
            aria-label="Next memberships"
            className="btn btn-outline-dark btn-sm"
            disabled={!scrollState.next}
            onClick={() => scroll(1)}
            type="button"
          >
            <span aria-hidden="true">→</span>
          </button>
        </div>
      )}
      <div
        aria-label="Membership plans"
        className="membership-packages-row text-center"
        onFocus={event => {
          if (event.target !== event.currentTarget) {
            event.target.scrollIntoView({block: 'nearest', inline: 'nearest'});
          }
        }}
        onScroll={updateScrollState}
        ref={rowRef}
        role="region"
        tabIndex={0}
      >
        {plans.map(plan => (
          <MembershipPackUI companyId={companyId} key={plan?.planId} plan={plan} />
        ))}
      </div>
    </div>
  );
};

export default MembershipPacksRow;
